/**
 * Created by mqamhieh on 10/9/17.
 */
(function (app) {

    app.controller('CEBAssessmentStatusModal', [
        '$scope', 'brandData', 'cardData', 'onAssessmentCanceled',
        function ($scope, brandData, cardData, onAssessmentCanceled) {

            $scope.close = function () {
                $scope.$hide();
            };

            $scope.STATUSES = TalentAssessmentAPI.STATUSES;
            $scope.loading = true;

            TalentAssessmentAPI.getCandidateStatusDetails(brandData.id, cardData.assessment_status.id)
                .then(function (assessmentDetails) {
                    $scope.assessmentDetails = assessmentDetails;
                    delete $scope.loading;
                    $scope.$digest();
                }, function (err) {
                    console.error(err);
                    $scope.close();
                    $scope.$digest();
                });

            $scope.cancelAssessments = function () {
                hConfirm({
                    title: $filter("translate")("Cancel Assessments"),
                    text: $filter("translate")("Are you sure you want to cancel all assessments?") + "<br/>" + $filter("translate")("This will delete all candidate data."),
                    cancelButton: $filter("translate")("Close"),
                    callback: function (confirmed) {
                        if (confirmed) {
                            $scope.canceling = true;

                            TalentAssessmentAPI.cancelCandidateAssessments(brandData.id, cardData.assessment_status.id)
                                .then(function () {
                                    $scope.close();
                                    onAssessmentCanceled();
                                    $scope.$digest();
                                }, function (err) {
                                    console.error(err);
                                    $scope.close();
                                    $scope.$digest();
                                });

                            $scope.$digest();
                        }
                    }
                });
            };

        }]);

})(angular.module('harriApp'));